import { User } from "../types/User";

export const contentHeader = () => {
  const userString = localStorage.getItem("e-user");

  if (userString && userString !== "undefined") {
    const user: User = JSON.parse(userString);
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Token ${user?.token}`,
    };
    return headers;
  }
};

export const multipartHeader = () => {
  const userString = localStorage.getItem("e-user");

  if (userString && userString !== "undefined") {
    const user: User = JSON.parse(userString);
    const headers = {
      "Content-Type": "multipart/form-data",
      Authorization: `Token ${user?.token}`,
    };
    return headers;
  }
};
